module.exports = __webpack_public_path__ + "img/Ma'ami_Cercle.ff47b368.png";